import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";

import notSearchedImg from "../../../assets/images/Curly Arrow.svg";
import noResultImg from "../../../assets/images/no-result-img.svg";

import { LinkButton, PrimaryButton } from "../../atoms/Buttons";
import PageHero from "../../molecules/PageHero";
import { H3, P } from "../../atoms/Texts";
import { DarkFormField } from "../../atoms/Inputs";
import { OrganizationCard } from "../../atoms/Cards";

const ClaimOrganizationPage = () => {
  const navigate = useNavigate();

  const [results, setResults] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [page, setPage] = useState(0);
  const [, setCanLoadNextPage] = useState(false);
  const [pageRange, setPageRange] = useState([]);

  const {
    register,
    formState: { errors },
  } = useForm();

  return (
    <main>
      <PageHero
        title="Claim an organization"
        description="Claim your organization’s listing in our database"
      />
      <div className="container mt-6 flex justify-between items-center">
        <form className="md:w-2/5">
          <div className="flex flex-wrap lg:flex-no-wrap">
            <div className="w-full flex-grow">
              <DarkFormField
                type="search"
                id="query"
                name="query"
                className="py-1 flex w-full"
                placeholder="Search"
                data_testid="query-input"
                {...register("query", {
                  required: "Please enter a search phrase",
                })}
              />
              <ErrorMessage
                errors={errors}
                name="query"
                as={
                  <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />
                }
              >
                {({ messages }) =>
                  messages &&
                  Object.entries(messages).map(([type, message]) => (
                    <P key={type}>{message}</P>
                  ))
                }
              </ErrorMessage>
            </div>
            <div className="md:ml-4">
              <PrimaryButton>Search</PrimaryButton>
            </div>
          </div>
        </form>
      </div>
      <section className="container pb-10">
        {!hasSearched ? (
          <div className=" pt-16 flex flex-col items-center mt-6">
            <img src={notSearchedImg} alt="" className="" />
            <H3 color="#22202D" className="mt-6">
              Search for a listing
            </H3>
            <P fontSize="16px" color="#7D7B96" className="mt-4 mb-0 text-center">
              Input your organization name in the search bar above.
            </P>
            <Link to="/dashboard/create-organization">
              <PrimaryButton className="mx-auto mt-6" p="14px 24px">
                Add an organzation
              </PrimaryButton>
            </Link>
          </div>
        ) : (
          <>
            {results?.length < 1 ? (
              <div className=" pt-20 flex flex-col items-center mt-6 ">
                <img src={noResultImg} alt="" className="" />
                <H3 color="#22202D" className="mt-10">
                  No result found.
                </H3>
                <P fontSize="16px" color="#7D7B96" className="mt-2 mb-0 text-center">
                  Please refine your search and try again.
                </P>
              </div>
            ) : (
              <>
                <P color="#22202D" fontFamily="semi">
                  List of Organizations Available
                </P>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
                  {results?.map((organization) => (
                    <Link
                      key={organization.id}
                      to={`/dashboard/claim-specific-organization/${organization.id}`}
                    >
                      <OrganizationCard
                        location={organization?.locations?.address}
                        description={organization.description}
                        title={organization.name}
                      />
                    </Link>
                  ))}
                </div>
                <div className="flex items-center justify-center mt-6">
                  {pageRange.map((_page, index) => (
                    <LinkButton
                      key={index}
                      className="mr-4"
                      disabled={page === _page * 15}
                      onClick={() => setPage(_page * 15)}
                    >
                      {_page + 1}
                    </LinkButton>
                  ))}
                </div>
              </>
            )}
          </>
        )}
      </section>
    </main>
  );
};

export default ClaimOrganizationPage;
